// src/components/buttons/BtnCancelar.jsx
import React from "react";

export default function BtnCancelar({ onClick = () => {} }) {
  return (
    <button
      type="button"
      className="btn-fil btn-wide bg-gray-400 hover:bg-gray-500 text-white"
      onClick={onClick}
    >
      Cancelar
    </button>
  );
}
